import React, { Component, useCallback, useState, useEffect } from 'react';
import Divider from '@mui/material/Divider';
import authService from './api-authorization/AuthorizeService'

 
import moment from "moment/moment";
import IssueEvent from "./issues/issueEvent";
import DashboardEvent from "./dashboard/DashboardEvent";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import CastConnectedIcon from "@mui/icons-material/CastConnected";
import {Link} from "react-router-dom";
import FormDialog from "./project/formdialog";
import OnboardingBlankState from './onboarding/onboarding';
import DragDropInput from "./drag";
import HelpCenter from "./help/HelpCenter";
export default function Main({updateTitle}) {
    const summaryRequestRef = React.useRef({ id: 0, controller: null });

    const [dashboardData, setDashboard] = React.useState({feed: [],videos:[]});
    const [projects, setProjects] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [groupedEvents, setGroupedEvents] = React.useState([]);
    const [summaryOpen, setSummaryOpen] = React.useState(false);
    const [summaryProject, setSummaryProject] = React.useState(null);
    const [summaryLoading, setSummaryLoading] = React.useState(false);
    const [summaryError, setSummaryError] = React.useState("");

    const fetchProjects = async () => {
  
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/projects', {
            //headers: !token ? {} : {'X-Authorization': `Bearer ${token}`} }
        });
        authService.followIfLoginRedirect(response);
        const data = await response.json();
        setProjects(data);

    }
    useEffect(() => {
        // declare the async data fetching function
        updateTitle('Digitals');
        fetchData()
            // make sure to catch any error
            .catch(console.error);
        
        fetchProjects().catch(console.error);
    }, [])

    const fetchData = async () => {
        setLoading(true);
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/dashboard', {
            //headers: !token ? {} : {'X-Authorization': `Bearer ${token}`} }
        });
        setLoading(false);
        const data = await response.json();

        setDashboard(data);
        setisToday(moment(data.feed[0].event_date).isSame(moment(), 'day'));
        setGroupedEvents(groupEventsByKey(data.feed));
        
       
        
    }

    const groupEventsByKey = (events) => {
        return events.reduce((groups, event) => {
            const key = event.key; // Use the 'key' property to group
            if (!groups[key]) {
                groups[key] = [];
            }
            groups[key].push(event);
            return groups;
        }, {});
    };
    const [isToday, setisToday] = React.useState(true);
    let afterTodayInserted = false; // Flag to track if the title has been inserted

    const Loading = () => {
        return (
            <Box sx={{my:5}}>
                <Typography variant={"h5"} align={"center"}>Loading your feed...</Typography>
            </Box>
        )
    }
    
    const refresh = () => {
        fetchProjects().catch(console.error);
    }

    const openSummary = async (project) => {
        if (summaryRequestRef.current.controller) {
            summaryRequestRef.current.controller.abort();
        }

        const controller = new AbortController();
        const requestId = summaryRequestRef.current.id + 1;
        summaryRequestRef.current = { id: requestId, controller };

        setSummaryOpen(true);
        setSummaryLoading(true);
        setSummaryError("");
        setSummaryProject(null);

        try {
            const response = await fetch(`/api/projects/details/${project.id}/summary`, {
                signal: controller.signal
            });
            authService.followIfLoginRedirect(response);
            if (!response.ok) {
                throw new Error(`Summary request failed (${response.status})`);
            }
            const data = await response.json();
            if (summaryRequestRef.current.id === requestId) {
                setSummaryProject(data);
            }
        } catch (e) {
            if (e?.name === "AbortError") {
                return;
            }
            if (summaryRequestRef.current.id === requestId) {
                setSummaryError("Could not load project summary right now.");
            }
        } finally {
            if (summaryRequestRef.current.id === requestId) {
                setSummaryLoading(false);
            }
        }
    };

    const closeSummary = () => {
        if (summaryRequestRef.current.controller) {
            summaryRequestRef.current.controller.abort();
        }
        summaryRequestRef.current = { id: summaryRequestRef.current.id + 1, controller: null };
        setSummaryOpen(false);
        setSummaryProject(null);
        setSummaryError("");
        setSummaryLoading(false);
    };

    useEffect(() => {
        return () => {
            if (summaryRequestRef.current.controller) {
                summaryRequestRef.current.controller.abort();
            }
        };
    }, []);
    const noProjects = () => {
        return (
            <Box sx={{my:5}}>
                

                {authService.isInRole(["ADMIN", "CREATEPROJECT"]) && (

                    <Grid>
                        <OnboardingBlankState
                            endpointUrl="/api/dashboard/steps"
                            renderModalContent={(step, close, refresh) => (
                                <>
                                    <FormDialog
                                        show={true}
                                        step={step}
                                        items={[]}
                                        cb={async () => {
                                            await refresh(); // re-fetch step status
                                            close();         // then close the modal
                                        }}
                                    />
                                </>
                            )}
                        />
                    </Grid>
                )}

                {!authService.isInRole(["ADMIN", "CREATEPROJECT"]) && (

                    <Grid>
                        <Typography variant={"h5"} align={"center"}>No projects setup yet</Typography>
                        <Typography align={"center"} sx={{mx:10, mt:5}}>Ask your team admin to setup a project. </Typography>
                    </Grid>
                )}
            </Box>
        )
    }
    
    return (
        <div>
            <Grid>

                {projects && projects.length > 0 && (<>

                    <Typography align="center" sx={{mb:1,fontSize:15}}>
                        Recent projects below. <Link tag={Button}  to={'/projects/'}>
                        Full List
                    </Link>
                    </Typography>
                </>)}
                <Grid container spacing={2}  direction="row"
                      justifyContent="center"
                      alignItems="center">
                    
                    {projects.map((project) => (
                        <Grid item xs={6} md={3}>
                            <Card elevation={1} key={project.id}  sx={{ p:{xs:0,md:0}}}>

                                <CardContent sx={{height: 175, p:{xs:0.5,md:2}}}>

                                        <Link tag={Button}  to={'/projects/' + project.id}>
                                            <Typography component="h5" variant="h6" align={'center'}>{project.name}</Typography>
                                        </Link>
                                    <Typography sx={{mt:2, fontSize:30, fontWeight:'bold'}} align="center">{project.pending_items}</Typography>
                                    <Typography sx={{mt:0, fontSize:20}} align="center">pending videos</Typography>

                                    
                                </CardContent>
                                <CardActions sx={{display:'flex', justifyContent:'space-between'}}>
                                    <Typography align="center"  sx={{color:'#c0c0c0', fontSize: 14}}>
                                        updated {moment(project.dateLastEntry).fromNow()}
                                    </Typography>
                                    <Button size="small" variant="outlined" onClick={() => openSummary(project)}>
                                        Summary
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}

                    {!loading && projects.length == 0 && noProjects()}
                </Grid>
                
                <Grid container spacing={2} justifyContent={"center"}>

                    <Grid item xs={12} md={8}>
                            <Divider sx={{my: 5}}>FEED</Divider>
                            <Stack spacing={2}>
                                {loading && (Loading())}

                                {Object.keys(groupedEvents).map((key) => {
                                    let content = (
                                        <Paper sx={{p: 1}}>
                                            <DashboardEvent key={key} rows={groupedEvents[key]} />
                                        </Paper>);
                                    if(!afterTodayInserted && isToday && !moment(groupedEvents[key][0].event_date).isSame(moment(), 'day')){
                                        afterTodayInserted = true;
                                        return (
                                            <React.Fragment key={key}>
                                                <h2>Older events</h2>
                                                {content}
                                            </React.Fragment>
                                        )
                                    }
                                    return content;

                                })}
                            </Stack>
                        </Grid>

                    <Grid item xs={12} md={4}>
                        <Divider sx={{ my: 5 }}>CHANNEL UPDATES</Divider>

                        <Stack spacing={3}>
                            {loading && Loading()}

                            {!loading && dashboardData.videos.map((channel) => (
                                <Box
                                    key={channel.channelId}
                                    sx={{ p: 2, border: '1px solid #eee', borderRadius: 2, bgcolor: 'background.paper' }}
                                >
                                    {/* Channel info */}
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        {channel.channelName}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                        @{channel.channelHandle} · {channel.channelType}
                                    </Typography>

                                    {/* Channel's videos */}
                                    <Stack spacing={1}>
                                        {channel.videos.map((v) => (
                                            <Box
                                                key={v.video.id}
                                                sx={{
                                                    p: 1,
                                                    borderRadius: 1,
                                                    bgcolor: '#f9f9f9'  // light grey background
                                                }}
                                            >
                                                <Typography variant="body2">{v.video.video_title}</Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    {moment(v.video.date_received).fromNow()}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Stack>
                                </Box>
                            ))}
                        </Stack>
                    </Grid>
                </Grid>

            </Grid>

            <Dialog
                open={summaryOpen}
                onClose={closeSummary}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    {summaryProject?.project_name || "Project summary"}
                </DialogTitle>
                <DialogContent dividers>
                    {summaryLoading && (
                        <Box sx={{display:'flex', justifyContent:'center', py:4}}>
                            <CircularProgress size={28} />
                        </Box>
                    )}

                    {!summaryLoading && summaryError && (
                        <Typography color="error">{summaryError}</Typography>
                    )}

                    {!summaryLoading && !summaryError && summaryProject && (
                        <Stack spacing={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={6} md={3}>
                                    <Typography sx={{fontSize:12, color:'#888'}}>Pending videos</Typography>
                                    <Typography sx={{fontSize:24, fontWeight:'bold'}}>{summaryProject.pending_videos}</Typography>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <Typography sx={{fontSize:12, color:'#888'}}>Channels</Typography>
                                    <Typography sx={{fontSize:24, fontWeight:'bold'}}>{summaryProject.channel_count}</Typography>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <Typography sx={{fontSize:12, color:'#888'}}>Brands</Typography>
                                    <Typography sx={{fontSize:24, fontWeight:'bold'}}>{summaryProject.brand_count}</Typography>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <Typography sx={{fontSize:12, color:'#888'}}>Last updated</Typography>
                                    <Typography sx={{fontSize:16, fontWeight:'bold'}}>
                                        {summaryProject.last_updated ? moment(summaryProject.last_updated).fromNow() : "n/a"}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Box>
                                <Typography sx={{fontWeight:600, mb:1}}>Brands</Typography>
                                <Stack direction="row" spacing={1} sx={{flexWrap:'wrap', gap:1}}>
                                    {summaryProject.brands?.length
                                        ? summaryProject.brands.map((name) => <Chip key={name} size="small" label={name} />)
                                        : <Typography sx={{color:'#888'}}>No brands assigned</Typography>}
                                </Stack>
                            </Box>

                            <Box>
                                <Typography sx={{fontWeight:600, mb:1}}>Domains</Typography>
                                <Stack direction="row" spacing={1} sx={{flexWrap:'wrap', gap:1}}>
                                    {summaryProject.domains?.length
                                        ? summaryProject.domains.map((domain) => <Chip key={domain} size="small" label={domain} />)
                                        : <Typography sx={{color:'#888'}}>No domains assigned</Typography>}
                                </Stack>
                            </Box>

                            <Box>
                                <Typography sx={{fontWeight:600, mb:1}}>Most recent videos</Typography>
                                <Stack spacing={1}>
                                    {summaryProject.recent_videos?.length
                                        ? summaryProject.recent_videos.map((v) => (
                                            <Paper key={v.report_entry_id} sx={{p:1.25, border:'1px solid #eee'}}>
                                                <Typography sx={{fontWeight:600}}>{v.video_title || `Video #${v.video_id}`}</Typography>
                                                <Typography sx={{fontSize:13, color:'#777'}}>
                                                    {v.channel_name ? `@${v.channel_name} · ` : ""}
                                                    {moment(v.date_created).fromNow()}
                                                </Typography>
                                                <Link tag={Button} to={`/projects/${summaryProject.project_id}/entry/${v.report_entry_id}`}>
                                                    Open entry
                                                </Link>
                                            </Paper>
                                        ))
                                        : <Typography sx={{color:'#888'}}>No recent videos found</Typography>}
                                </Stack>
                            </Box>
                        </Stack>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeSummary}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}
